import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

//Components
import Button from "../Components/Other Components/button";

//CSS
import "./notFoundPage.css";
import "../Components/Other Components/crashCover.css";

import { useTranslation } from "react-i18next";

const AccessDeniedPage = () => {
  const navigate = useNavigate();

  const { t } = useTranslation();
  return (
    <motion.div
      className="crash-cover"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <h2 className="crash-cover-header">{t("Access Denied") + "!"}</h2>
      <p className="crash-cover-text">
        {t("Sorry, you do not have the permission to access this page.")}
      </p>
      <div className="btn-container w-100">
        <Button onClick={() => navigate(-1)}>{t("Go Back")}</Button>
      </div>
    </motion.div>
  );
};

export default AccessDeniedPage;
